class SystemSettingRequestModel {
    constructor({
        id = "",
        value = "",
    } = {}) {
        this.id = id;
        this.value = value;
    }
}
export default SystemSettingRequestModel;
